import Vue from 'vue'

export default {
  methods : {
    computeTeamBet (betForm, isMinibet) {
      var redFont = ''
      var isRbScore = false
      var scoreCapt = ''

      if(betForm && typeof(betForm.eventObj.rbinfo) !== 'undefined') {
        isRbScore = true
        // scoreCapt += '&nbsp;<span class="betinfo-tsco">[' + betForm.rbscoa + '-' + betForm.rbscob + ']</span>'
      }

      var retCapt = ''
      switch(betForm.betType) {
        case this.hdpBetType :
        case this.rhdpBetType :
          if(betForm.betType==1 ||  betForm.betType==8){
            if(betForm.colorDis==1){
              redFont = 'teamHA_r_mini'
            }
          }

          if(isMinibet) {
            retCapt = '<span class="betinfo-tbet '+redFont+'">' + betForm.tbetcapt+ '</span>'
          } else {
            retCapt = '<span class="betinfo-tbet '+redFont+'">' + betForm.tbetcapt
            if(betForm.tbet == betForm.fav) {
              retCapt += '</span>&nbsp;<span class="betinfo-hdp red">(' + betForm.hdpCap + ')</span>'
            } else {
              retCapt += '</span>&nbsp;<span class="betinfo-hdp">' + betForm.hdpCap + '</span>'
            }
          }
          
          if(isRbScore) {
            retCapt += scoreCapt
          }
          return retCapt
          break;
        case this.ouBetType :
        case this.rouBetType  :
        case this.htgBetType :
        case this.rhtgBetType  :
        case this.atgBetType :
        case this.ratgBetType  :
          var capt = betForm.tbet == 'a'
            ? 'ALL_BET.LBL_OVER'
            : 'ALL_BET.LBL_UNDER'
          if(isMinibet)
            retCapt = '<span class="betinfo-tbet">' + this.$store.getters.sportAllBetLang[capt] + '</span>'
            retCapt = '<span class="betinfo-tbet">' + this.$store.getters.sportAllBetLang[capt] + '</span>&nbsp;'
            // retCapt += '<span class="betinfo-hdp">' + betForm.hdpCap + '</span>'
          if(isRbScore) {
            retCapt += scoreCapt
          }
          return retCapt
          break;
        case this.bttsBetType :
        case this.rbttsBetType  :
          var capt = betForm.tbet == 'a'
            ? 'ALL_BET.LBL_YES'
            : 'ALL_BET.LBL_NO'
          if(isMinibet)
            retCapt = '<span class="betinfo-tbet">' + this.$store.getters.sportAllBetLang[capt] + '</span>'
            retCapt = '<span class="betinfo-tbet">' + this.$store.getters.sportAllBetLang[capt] + '</span>&nbsp;'
            // retCapt += '<span class="betinfo-hdp">' + betForm.hdpCap + '</span>'
          if(isRbScore) {
            retCapt += scoreCapt
          }
          return retCapt
          break;
        case this.h1x2BetType:
        case this.rh1x2BetType:
        case this.twnBetType:
        case this.rtwnBetType:
        case this.twfbBetType:
        case this.rtwfbBetType:
        case this.twehBetType:
        case this.rtwehBetType:
        case this.twbhBetType:
        case this.rtwbhBetType:
        case this.tsbhBetType:
        case this.rtsbhBetType:
          var capt = ''

          if(betForm.tbet == 'a'){
            capt = 'ALL_BET.LBL_HOME'
          }else if(betForm.tbet == 'b'){
            capt = 'ALL_BET.LBL_AWAY'
          }else if(betForm.tbet == 'x'){
            capt = 'ALL_BET.LBL_DRAW'
          }
          
          if(isMinibet)
            retCapt = '<span class="betinfo-tbet">' + this.$store.getters.sportAllBetLang[capt] + '</span>'
            retCapt = '<span class="betinfo-tbet">' + this.$store.getters.sportAllBetLang[capt] + '</span>&nbsp;'

          if(isRbScore) {
            retCapt += scoreCapt
          }
          return retCapt
          break;
        case this.wmBetType:
        case this.rwmBetType:
          var capt = ''

          if(betForm.tbet == 'h1'){
            capt = 'ALL_BET.LBL_HWB1'
          }else if(betForm.tbet == 'h2'){
            capt = 'ALL_BET.LBL_HWB2'
          }else if(betForm.tbet == 'h3'){
            capt = 'ALL_BET.LBL_HWB3'
          }else if(betForm.tbet == 'h4'){
            capt = 'ALL_BET.LBL_HWB4M'
          }else if(betForm.tbet == 'a1'){
            capt = 'ALL_BET.LBL_AWB1'
          }else if(betForm.tbet == 'a2'){
            capt = 'ALL_BET.LBL_AWB2'
          }else if(betForm.tbet == 'a3'){
            capt = 'ALL_BET.LBL_AWB3'
          }else if(betForm.tbet == 'a4'){
            capt = 'ALL_BET.LBL_AWB4M'
          }else if(betForm.tbet == 'sd'){
            capt = 'ALL_BET.LBL_AS'
          }else if(betForm.tbet == 'ng'){
            capt = 'ALL_BET.LBL_NG'
          }
          
          if(isMinibet)
            retCapt = '<span class="betinfo-tbet">' + this.$store.getters.sportAllBetLang[capt] + '</span>'
            retCapt = '<span class="betinfo-tbet">' + this.$store.getters.sportAllBetLang[capt] + '</span>&nbsp;'
            
          if(isRbScore) {
            retCapt += scoreCapt
          }
          return retCapt
          break;
        case this.wmrBetType:
        case this.rwmrBetType:
          var capt = ''

          if(betForm.tbet == 'h1'){
            capt = 'ALL_BET.LBL_HWB1R'
          }else if(betForm.tbet == 'h2'){
            capt = 'ALL_BET.LBL_HWB2R'
          }else if(betForm.tbet == 'h3'){
            capt = 'ALL_BET.LBL_HWB3R'
          }else if(betForm.tbet == 'h4'){
            capt = 'ALL_BET.LBL_HWB4RM'
          }else if(betForm.tbet == 'a1'){
            capt = 'ALL_BET.LBL_AWB1R'
          }else if(betForm.tbet == 'a2'){
            capt = 'ALL_BET.LBL_AWB2R'
          }else if(betForm.tbet == 'a3'){
            capt = 'ALL_BET.LBL_AWB3R'
          }else if(betForm.tbet == 'a4'){
            capt = 'ALL_BET.LBL_AWB4RM'
          }else if(betForm.tbet == 'sd'){
            capt = 'ALL_BET.LBL_AS'
          }
          
          if(isMinibet)
            retCapt = '<span class="betinfo-tbet">' + this.$store.getters.sportAllBetLang[capt] + '</span>'
            retCapt = '<span class="betinfo-tbet">' + this.$store.getters.sportAllBetLang[capt] + '</span>&nbsp;'
            
          if(isRbScore) {
            retCapt += scoreCapt
          }
          return retCapt
          break;
        case this.flgBetType:
          var capt = ''

          if(betForm.tbet == 'hf'){
            capt = 'ALL_BET.SUBHEADER_HF'
          }else if(betForm.tbet == 'hl'){
            capt = 'ALL_BET.SUBHEADER_HL'
          }else if(betForm.tbet == 'af'){
            capt = 'ALL_BET.SUBHEADER_AF'
          }else if(betForm.tbet == 'al'){
            capt = 'ALL_BET.SUBHEADER_AL'
          }else if(betForm.tbet == 'ng'){
            capt = 'ALL_BET.LBL_NG'
          }
          
          if(isMinibet)
            retCapt = '<span class="betinfo-tbet">' + this.$store.getters.sportAllBetLang[capt] + '</span>'
            retCapt = '<span class="betinfo-tbet">' + this.$store.getters.sportAllBetLang[capt] + '</span>&nbsp;'
            
          if(isRbScore) {
            retCapt += scoreCapt
          }
          return retCapt
          break;
        case this.hmgBetType:
        case this.rhmgBetType:
        case this.hmg1x2BetType:
        case this.rhmg1x2BetType:
          var capt = ''

          if(betForm.tbet == 'a'){
            capt = 'ALL_BET.LBL_1HT'
          }else if(betForm.tbet == 'b'){
            capt = 'ALL_BET.LBL_2HT'
          }else if(betForm.tbet == 'x'){
            capt = 'ALL_BET.LBL_DRAW'
          }
          
          if(isMinibet)
            retCapt = '<span class="betinfo-tbet">' + this.$store.getters.sportAllBetLang[capt] + '</span>'
            retCapt = '<span class="betinfo-tbet">' + this.$store.getters.sportAllBetLang[capt] + '</span>&nbsp;'
            
          if(isRbScore) {
            retCapt += scoreCapt
          }
          return retCapt
          break;
        case this.wdBetType:
          var capt = ''
          var teamName = ''

          if(betForm.tbet == 'h_1_5'){
            teamName = 'ALL_BET.LBL_HOME'
            capt = 'ALL_BET.LBL_WIN_BY_1T5'
          }else if(betForm.tbet == 'h_6_10'){
            teamName = 'ALL_BET.LBL_HOME'
            capt = 'ALL_BET.LBL_WIN_BY_6T10'
          }else if(betForm.tbet == 'h_11_15'){
            teamName = 'ALL_BET.LBL_HOME'
            capt = 'ALL_BET.LBL_WIN_BY_11T15'
          }else if(betForm.tbet == 'h_16_20'){
            teamName = 'ALL_BET.LBL_HOME'
            capt = 'ALL_BET.LBL_WIN_BY_16T20'
          }else if(betForm.tbet == 'h_21_25'){
            teamName = 'ALL_BET.LBL_HOME'
            capt = 'ALL_BET.LBL_WIN_BY_21T25'
          }else if(betForm.tbet == 'h_26_x'){
            teamName = 'ALL_BET.LBL_HOME'
            capt = 'ALL_BET.LBL_WIN_BY_26MORE'
          }else if(betForm.tbet == 'a_1_5'){
            teamName = 'ALL_BET.LBL_AWAY'
            capt = 'ALL_BET.LBL_WIN_BY_1T5'
          }else if(betForm.tbet == 'a_6_10'){
            teamName = 'ALL_BET.LBL_AWAY'
            capt = 'ALL_BET.LBL_WIN_BY_6T10'
          }else if(betForm.tbet == 'a_11_15'){
            teamName = 'ALL_BET.LBL_AWAY'
            capt = 'ALL_BET.LBL_WIN_BY_11T15'
          }else if(betForm.tbet == 'a_16_20'){
            teamName = 'ALL_BET.LBL_AWAY'
            capt = 'ALL_BET.LBL_WIN_BY_16T20'
          }else if(betForm.tbet == 'a_21_25'){
            teamName = 'ALL_BET.LBL_AWAY'
            capt = 'ALL_BET.LBL_WIN_BY_21T25'
          }else if(betForm.tbet == 'a_26_x'){
            teamName = 'ALL_BET.LBL_AWAY'
            capt = 'ALL_BET.LBL_WIN_BY_26MORE'
          }
          
          if(isMinibet)
            retCapt = '<span class="betinfo-tbet">' + this.$store.getters.sportAllBetLang[teamName] + ' ' + this.$store.getters.sportAllBetLang[capt] + '</span>'
            retCapt = '<span class="betinfo-tbet">' + this.$store.getters.sportAllBetLang[teamName] + ' ' + this.$store.getters.sportAllBetLang[capt] + '</span>&nbsp;'

          if(betForm.tbet == 'h_26_x' || betForm.tbet == 'a_26_x'){
            retCapt = retCapt.replace('26', '26+')
          }
            
          if(isRbScore) {
            retCapt += scoreCapt
          }
          return retCapt
          break;
        case this.hldsBetType:
        case this.rhldsBetType:
        case this.aldsBetType:
        case this.raldsBetType:
          var capt = ''

          if(betForm.tbet == '0_5'){
            capt = 'ALL_BET.LBL_05'
          }else if(betForm.tbet == '1_6'){
            capt = 'ALL_BET.LBL_16'
          }else if(betForm.tbet == '2_7'){
            capt = 'ALL_BET.LBL_27'
          }else if(betForm.tbet == '3_8'){
            capt = 'ALL_BET.LBL_38'
          }else if(betForm.tbet == '4_9'){
            capt = 'ALL_BET.LBL_49'
          }
          
          if(isMinibet)
            retCapt = '<span class="betinfo-tbet">' + this.$store.getters.sportAllBetLang[capt] + '</span>'
            retCapt = '<span class="betinfo-tbet">' + this.$store.getters.sportAllBetLang[capt] + '</span>&nbsp;'
            
          if(isRbScore) {
            retCapt += scoreCapt
          }
          return retCapt
          break;
        default   :
          retCapt = betForm.tbetcapt
          if(isRbScore) {
            retCapt += scoreCapt
          }
          return retCapt;
      }
    },
    calcForecastWL(plytyp, scoreKey) {
      var amntWL = 0
      var event = null
      if(this.selectedForecastEvent) {
        if(this.selectedForecastEvent[plytyp]) {
          for(var bettyp = 0; bettyp < Object.keys(this.selectedForecastEvent[plytyp]).length ; bettyp++) {
            var bettypKey = Object.keys(this.selectedForecastEvent[plytyp])[bettyp]
            for(var tbet = 0; tbet < Object.keys(this.selectedForecastEvent[plytyp][bettypKey]).length ; tbet++) {
              var tbetKey = Object.keys(this.selectedForecastEvent[plytyp][bettypKey])[tbet]
              event = this.selectedForecastEvent[plytyp][bettypKey][tbetKey]

              if(this.selectedForecastEvent[plytyp][bettypKey][tbetKey].forecastInfo && this.selectedForecastEvent[plytyp][bettypKey][tbetKey].check) {
                amntWL += this.selectedForecastEvent[plytyp][bettypKey][tbetKey].forecastInfo[scoreKey]
              }
            }
          }
        }
      }
      if(plytyp == null){
        var cloneWagerList = _.cloneDeep(this.$store.getters.sportWaitingWagerList);
        for (let key = 0; key < Object.keys(cloneWagerList).length; key++) {
          const plytypKey = Object.keys(cloneWagerList)[key];
          if(typeof cloneWagerList[plytypKey] == 'object') {
            var wg = cloneWagerList[plytypKey]
            amntWL += wg.forecastInfo[scoreKey]
          }
        }
      }

      if(plytyp != null) {
        var cloneWagerList = _.cloneDeep(this.$store.getters.sportWaitingWagerList);
        if(cloneWagerList) {
          if(cloneWagerList[plytyp]) {
            var wg = cloneWagerList[plytyp]
            amntWL += wg.forecastInfo[scoreKey]
          }
        }
      }

      return amntWL
    },
    showRBScore(plytyp, scoreKey) {
      var showRbSco = false
      if(this.sportForecastSelectedEvent && this.sportForecastSelectedEvent.rbinfo) {
        var rbsco = this.sportForecastSelectedEvent.rbinfo['scoa'] + '_' + this.sportForecastSelectedEvent.rbinfo['scob']
        if(rbsco == scoreKey) {
          showRbSco = true
        }
      }
      return showRbSco
    },
    checkWaitingWagerForecastInfoExist(event, plytyp, bettyp, tbet) {
      if(this.waitingWagerList.length > 0) {
        var tbet = null
        var forecastTbet = null
        var forecastHdp = null

        forecastTbet = event.tbet
        forecastHdp = event.hdp

        switch(bettyp) {
          case this.onex2BetType:
          case this.ronex2BetType:
            if(event.tbet == 'a') {
              tbet = event.eventObj.taid
            }
            else if (event.tbet == 'b') {
              tbet = event.eventObj.tbid
            }
            else if (event.tbet == 'x') {
              tbet = 'draw'
            }
            else {
              console.log('Error: hdp check wager')
            }
            break;
          case this.hdpBetType:
          case this.rhdpBetType:
            if(event.tbet == 'a') {
              tbet = event.eventObj.taid
            }
            else if (event.tbet == 'b') {
              tbet = event.eventObj.tbid
            }
            else {
              console.log('Error: hdp check wager')
            }
            break;
          case this.ouBetType:
          case this.rouBetType:
            if(event.tbet == 'a') {
              tbet = 'over'
            }
            else if (event.tbet == 'b') {
              tbet = 'under'
            }
            else {
              console.log('Error: ou check wager')
            }
            break;
          case this.oeBetType:
          case this.roeBetType:
            if(event.tbet == 'a') {
              tbet = 'odd'
            }
            else if (event.tbet == 'b') {
              tbet = 'even'
            }
            else {
              console.log('Error: oe check wager')
            }
            break;
          default:
            //Not supported
            return;
        }
        var cloneWagerList = _.cloneDeep(this.waitingWagerList)
        var filterWagerList = _.filter(cloneWagerList, {
          'eveId': String(event.eventObj.eveid),
          'plyTypId': String(plytyp),
          //'betTypId': String(bettyp),
          //'tbetid': String(tbet),
        })
        filterWagerList = _.map(filterWagerList, (wager) => {
          wager.tbet = forecastTbet
          wager.betAmount = wager.stkF
          wager.odd = parseFloat(wager.od)
          wager.hdp = String(wager.hdp)
          var isTwoHdp = wager.hdp.indexOf('/');
          if(isTwoHdp >= 0) {
            var hdpValues = wager.hdp.split('/')
            wager.hdp = (parseFloat(hdpValues[0]) + parseFloat(hdpValues[1]) ) / 2
          } else {
            wager.hdp = parseFloat(wager.hdp)
          }
          return wager
        })
        return filterWagerList
      }
      return []
    },
    get_winlose_amt(wl,betamt,odds,wl_percentage, bet_info) {
      odds = parseFloat(odds)
      var wl_amt,wl_inc_amt = 0;
      if(wl=='w'){
        if( odds < 0 ){
          wl_amt = betamt * wl_percentage;
        }else{
          wl_amt = betamt * odds * wl_percentage;
        }
      }else if(wl=='l'){
        if( odds < 0 ){
          wl_amt = betamt * odds * wl_percentage;
        }else{
          wl_amt = betamt * -1 * wl_percentage;
        }
      }else if(wl=='d'){
        wl_amt = 0;
      }

      var inc_amt = this.calc_inc(wl,betamt,odds,wl_percentage, bet_info,wl_amt);
      wl_amt =   wl_amt+inc_amt;
      return wl_amt;
    },
    calc_inc(wl,betamt,odds,wl_percentage, bet_info,wl_amt){
      var wl_incentive_calc_flag = 1;
      //ah, ou, oe, rah, rou, roe
      var wl_incentive_calc_flag_bettype = ["1","2","3","8","9","10","46","47","48","49","80","81","82","83"];
      var inc_percentage 	= this.$store.getters.betting.incentive;
      var inc_amt = 0;

      if(wl=='d'){
        inc_percentage = 0;
      }else if(wl_percentage== 0.5){
        //win half/lose half
        if( wl_incentive_calc_flag== 1 && $.inArray( bet_info['betType'] , wl_incentive_calc_flag_bettype ) != -1){
          inc_percentage = inc_percentage;
        }else{
          inc_percentage = inc_percentage/2;
        }
      }else{
        //win/lose
        inc_percentage = inc_percentage;
      }

      if( wl_incentive_calc_flag== 1 && $.inArray( bet_info['betType'] , wl_incentive_calc_flag_bettype ) != -1){
        inc_amt = 	Math.abs(wl_amt) * inc_percentage;
      }else{
        inc_amt = 	betamt * inc_percentage;
      }
      //inc_amt = inc_amt/100;
      return inc_amt;
    },
    olc_ou(bet_info, hc, ac) {
      var arr_return    = {};
      arr_return      = bet_info;
      arr_return['forecastInfo'] = {};

      if( bet_info['tbet'] == 'a' || bet_info['tbet'] == 'b' ){
        for(var c=0;c<=hc;c++){
          for(var r=0;r<=ac;r++){
            //c = home team, r = away
            
            var hdp = parseFloat(bet_info['hdp'])
            hdp = bet_info['hdpVal'] ? parseFloat(bet_info['hdpVal']) : hdp;
            
            var total = 0
            if( bet_info['betTypId'] == 46 || bet_info['betTypId'] == 47 || bet_info['betTypId'] == 80 || bet_info['betTypId'] == 81){
              total = c
            }else if ( bet_info['betTypId'] == 48 || bet_info['betTypId'] == 49 || bet_info['betTypId'] == 82 || bet_info['betTypId'] == 83){
              total = r
            }else{
              total = r+c;
            }
            
            var wl_amt  = '-';

            var is_ou = '-';

            if( total > hdp ){
              is_ou = 'a';//over
            }else if( total < hdp ){
              is_ou = 'b';//under
            }else if(total == hdp ){
              is_ou = 'd';//draw
            }

            var wl_percentage = 1;
            var diff = Math.abs(total - hdp);
            if( diff == 0.25 ){
              wl_percentage = 0.5;
            }

            var wl = '';
            if (is_ou == bet_info['tbet']){
              wl = 'w';
            }else if (is_ou == 'd') {
              wl = 'd';
            }else{
              wl = 'l';
            }
            
            var od = bet_info['odd'];
            if(bet_info['odTypId'] == this.$store.getters.oddTypesList.EU.key) {
              od = bet_info['odd'] - 1;
            }
            if(bet_info['odTypId'] == this.$store.getters.oddTypesList.AM.key) {
              if(od<0){
                od=Math.abs(100/od);
              }else{
                od= (od / 100);
              }
              od= od.toFixed(3);
            }
            wl_amt = this.get_winlose_amt(wl,bet_info['betAmount'],od,wl_percentage, bet_info);
            arr_return['forecastInfo'][c+"_"+r] = wl_amt;
          }
        }
      }else{
        console.log('error -> olc_ou');
        return false;
      }
      return arr_return;
    },
    olc_oe(bet_info, hc, ac){

      if( bet_info['tbet'] == 'a' || bet_info['tbet'] == 'b' ){
        var arr_return    = {};
        arr_return      = bet_info;
        arr_return['forecastInfo'] = {};

        for(var c=0;c<=hc;c++){
          for(var r=0;r<=ac;r++){
            var total = r+c;
            var wl_amt  = '-';

            var is_oe = 'a';//o
            if( (total % 2) == '0' ){
              is_oe = 'b';//e
            }

            var wl = '';
            if( bet_info['tbet'] == is_oe){
              wl = 'w';
            }else{
              wl = 'l';
            }

            var od = bet_info['odd']
            if(bet_info['odTypId'] == this.$store.getters.oddTypesList.AM.key) {
              if(od<0){
                od=Math.abs(100/od);
              }else{
                od= (od / 100);
              }
              od= od.toFixed(3);
            }else if(od > 1) {
              if(bet_info['odTypId'] != this.$store.getters.oddTypesList.IN.key) {
                od = bet_info['odd'] - 1
              }
            }
            
            var wl_percentage = 1;
            var wl_amt  = 0;
            wl_amt = this.get_winlose_amt(wl,bet_info['betAmount'], od ,wl_percentage, bet_info);
            arr_return['forecastInfo'][c+"_"+r] = wl_amt;
          }
        }
      }else{
        console.log('error -> olc_oe');
        return false;
      }

      return arr_return;
    } ,
    olc_1x2(bet_info, hc, ac) {

      if( bet_info['tbet'] == 'a' || bet_info['tbet'] == 'b' || bet_info['tbet'] == 'x' ){
        var arr_return    = {};
        arr_return      = bet_info;
        arr_return['forecastInfo'] = {};

        for(var c=0;c<=hc;c++){
          for(var r=0;r<=ac;r++){
            //c = home team, r = away

            var is_ha = '';
            if(c==r){
              is_ha = 'x';//draw win
            }else if(c > r){
              is_ha = 'a';//home win
            }else if(c < r){
              is_ha = 'b';//away win
            }

            var wl = '';
            if( bet_info['tbet'] == is_ha){
              wl = 'w';
            }else{
              wl = 'l';
            }

            var od = bet_info['odd']
            if(bet_info['odTypId'] == this.$store.getters.oddTypesList.AM.key) {
              if(od<0){
                od=Math.abs(100/od);
              }else{
                od= (od / 100);
              }
              od= od.toFixed(3);
            }else if(od > 1) {
              od = bet_info['odd'] - 1
            }
            var wl_percentage = 1;
            var wl_amt  = 0;
            wl_amt = this.get_winlose_amt(wl,bet_info['betAmount'],od,wl_percentage, bet_info);
            arr_return['forecastInfo'][c+"_"+r] = wl_amt;

          }
        }
      }else{
        console.log('error -> olc_1x2');
        return false;
      }
      return arr_return;
    },
    olc_ah(bet_info, hc, ac) {
      if( bet_info['tbet'] == 'a' || bet_info['tbet'] == 'b' ){
        var arr_return    = {};
        arr_return      = bet_info;
        arr_return['forecastInfo'] = {};

        for(var c=0;c<=hc;c++){
          for(var r=0;r<=ac;r++){
            //c = home team, r = away
            var ch = c;
            var rh = r;
            var hdp = parseFloat(bet_info['hdp']);
            hdp = bet_info['hdpVal'] ? parseFloat(bet_info['hdpVal']) : hdp;
            // if rb = minus rb score
            if( bet_info.eventObj ){
              if( bet_info.eventObj.rbinfo ){
                ch = ch - parseInt(bet_info.eventObj.rbinfo['scoa']);
                rh = rh - parseInt(bet_info.eventObj.rbinfo['scob']);
              }
            }

            if( bet_info['tbet'] == 'a' ){
              ch = ch + hdp;
            }else if( bet_info['tbet'] == 'b' ){
              rh = rh + hdp;
            }

            var is_ha = '';
            if(ch==rh){
              is_ha = 'd';//draw win
            }else if(ch > rh){
              is_ha = 'a';//home win
            }else if(ch < rh){
              is_ha = 'b';//away win
            }
            // console.log(is_ha, ch, rh)
            var wl = '';
            if( is_ha == 'd'){
              wl = 'd';
            }else if( is_ha == bet_info['tbet']){
              wl = 'w';
            }else{
              wl = 'l';
            }

            var wl_percentage = 1;
            var diff = Math.abs(ch - rh);

            if( diff == 0.25 ){
              wl_percentage = 0.5;
            }
            var od = bet_info['odd'];
            if(bet_info['odTypId'] == this.$store.getters.oddTypesList.EU.key) {
              od = bet_info['odd'] - 1;
            }
            if(bet_info['odTypId'] == this.$store.getters.oddTypesList.AM.key) {
              if(od<0){
                od=Math.abs(100/od);
              }else{
                od= (od / 100);
              }
              od= od.toFixed(3);
            }
            var wl_amt  = '-';
            wl_amt = this.get_winlose_amt(wl,bet_info['betAmount'],od,wl_percentage, bet_info);
            arr_return['forecastInfo'][c+"_"+r] = wl_amt;

          }
        }
      }else{
        console.log('error -> olc_ah');
        return false;
      }

      return arr_return;
    },
    olc_cs(bet_info, hc, ac) {

      var arr_return    = {};
      arr_return      = bet_info;
      arr_return['forecastInfo'] = {};

      if( $.inArray( bet_info['tbet'].length , [3,4]) == -1 ){
        //not aos(3) and odxx(4)
        console.log('error->olc_cs');
        return false;
      }
      
      var tbet = bet_info['tbet'] =='aos' ? 'aos' : bet_info['tbet'];

      var betc = '';
      var betr = '';

      if(tbet=='aos'){
        betc = 'aos';
        betr = 'aos';
      } else {
        betc = tbet['2'];
        betr = tbet['3'];
      }

      for(var c=0;c<=hc;c++){
        for(var r=0;r<=ac;r++){
          //c = home team, r = away

          var wl = 'l';
          if(betc == c && betr == r){
            wl = 'w';//win
          } else if ((betc == 'aos' && c > 4) && (betr == 'aos' && r > 4)) {
            wl = 'w';
          }
          
          var od = bet_info['odd']
          
          if(bet_info['odTypId'] == this.$store.getters.oddTypesList.AM.key) {
            if(od<0){
              od=Math.abs(100/od);
            }else{
              od= (od / 100);
            }
            od= od.toFixed(3);
          }else if(od > 1) {
            od = bet_info['odd'] - 1
          }

          var wl_percentage = 1;
          var wl_amt  = '-';
          wl_amt = this.get_winlose_amt(wl,bet_info['betAmount'],od,wl_percentage, bet_info);
          arr_return['forecastInfo'][c+"_"+r] = wl_amt;

        }
      }

      return arr_return;
    },
    olc_tg(bet_info, hc, ac) {

      var arr_return    = {};
      arr_return      = bet_info;
      arr_return['forecastInfo'] = {};

      if( $.inArray( bet_info['tbet'] , ['tg01','tg23','tg456','tg7']) == -1 ){
        console.log('error->olc_tg');
        return false;
      }

      for(var c=0;c<=hc;c++){
        for(var r=0;r<=ac;r++){
          //c = home team, r = away
          var total = c + r;

          var wl = 'l';
          if( bet_info['tbet'] == 'tg01' ){
            if( $.inArray( total , [0,1]) != -1 ){
              wl = 'w';
            }
          }else if( bet_info['tbet'] == 'tg23' ){
            if( $.inArray( total , [2,3]) != -1 ){
              wl = 'w';
            }
          }else if( bet_info['tbet'] == 'tg456' ){
            if( $.inArray( total , [4,5,6]) != -1 ){
              wl = 'w';
            }
          }else if( bet_info['tbet'] == 'tg7' ){
            if( total >= 7 ){
              wl = 'w';
            }
          }

          var od = bet_info['odd']
          if(bet_info['odTypId'] == this.$store.getters.oddTypesList.AM.key) {
            if(od<0){
              od=Math.abs(100/od);
            }else{
              od= (od / 100);
            }
            od= od.toFixed(3);
          }else if(od > 1) {
            od = bet_info['odd'] - 1
          }

          var wl_percentage = 1;
          var wl_amt  = '-';
          wl_amt = this.get_winlose_amt(wl,bet_info['betAmount'],od,wl_percentage, bet_info);
          arr_return['forecastInfo'][c+"_"+r] = wl_amt;
        }
      }

      return arr_return;
    },
    getScoreDisplay(sco,rbsco, team) {
      if(rbsco && rbsco.rbinfo) {
        sco = parseInt(rbsco.rbinfo['sco' + team]) >= 2 ? parseInt(rbsco.rbinfo['sco' + team]) + (sco - 1) : sco
        //sco = rbsco.rbinfo['sco' + team] + sco
      }
      return sco
    },
    olc_h1x2(bet_info, hc, ac) {

      if( bet_info['tbet'] == 'a' || bet_info['tbet'] == 'b' || bet_info['tbet'] == 'x' ){
        var arr_return    = {};
        arr_return      = bet_info;
        arr_return['forecastInfo'] = {};

        for(var c=0;c<=hc;c++){
          for(var r=0;r<=ac;r++){
            //c = home team, r = away

            var hdp = parseFloat(bet_info['hdp']);
            hdp = bet_info['hdpVal'] ? parseFloat(bet_info['hdpVal']) : hdp;

            var homeDraw = parseFloat(c) - parseFloat(r) - hdp
            var away = parseFloat(r) + hdp - parseFloat(c)
            
            var is_ha = '';
            if(homeDraw == 0){
              is_ha = 'x';//draw win
            }else if(homeDraw > 0){
              is_ha = 'a';//home win
            }else if(away > 0){
              is_ha = 'b';//away win
            }

            var wl = '';
            if( bet_info['tbet'] == is_ha){
              wl = 'w';
            }else{
              wl = 'l';
            }

            var od = bet_info['odd']
            if(bet_info['odTypId'] == this.$store.getters.oddTypesList.AM.key) {
              if(od<0){
                od=Math.abs(100/od);
              }else{
                od= (od / 100);
              }
              od= od.toFixed(3);
            }else if(od > 1) {
              od = bet_info['odd'] - 1
            }
            var wl_percentage = 1;
            var wl_amt  = 0;
            wl_amt = this.get_winlose_amt(wl,bet_info['betAmount'],od,wl_percentage, bet_info);
            arr_return['forecastInfo'][c+"_"+r] = wl_amt;

          }
        }
      }else{
        console.log('error -> olc_h1x2');
        return false;
      }
      return arr_return;
    },
    olc_btts(bet_info, hc, ac) {

      if( bet_info['tbet'] == 'a' || bet_info['tbet'] == 'b' ){
        var arr_return    = {};
        arr_return      = bet_info;
        arr_return['forecastInfo'] = {};

        for(var c=0;c<=hc;c++){
          for(var r=0;r<=ac;r++){
            //c = home team, r = away
            
            var is_ha = '';
            if(c > 0 && r > 0){
              is_ha = 'a';//yes win
            }else if(c >= 0 || r >= 0){
              is_ha = 'b';//no win
            }

            var wl = '';
            if( bet_info['tbet'] == is_ha){
              wl = 'w';
            }else{
              wl = 'l';
            }

            var od = bet_info['odd']
            if(bet_info['odTypId'] == this.$store.getters.oddTypesList.AM.key) {
              if(od<0){
                od=Math.abs(100/od);
              }else{
                od= (od / 100);
              }
              od= od.toFixed(3);
            }else if(od > 1) {
              od = bet_info['odd'] - 1
            }
            var wl_percentage = 1;
            var wl_amt  = 0;
            wl_amt = this.get_winlose_amt(wl,bet_info['betAmount'],od,wl_percentage, bet_info);
            arr_return['forecastInfo'][c+"_"+r] = wl_amt;

          }
        }
      }else{
        console.log('error -> olc_btts');
        return false;
      }
      return arr_return;
    },
    olc_csh(bet_info, hc, ac) {

      if( bet_info['tbet'] == 'a' || bet_info['tbet'] == 'b' ){
        var arr_return    = {};
        arr_return      = bet_info;
        arr_return['forecastInfo'] = {};

        for(var c=0;c<=hc;c++){
          for(var r=0;r<=ac;r++){
            //c = home team, r = away
            
            var is_ha = '';

            if(bet_info['tbet'] == 'a'){
              if(c == 0){
                is_ha = 'a';//home win
              }
            }else if(bet_info['tbet'] == 'b'){
              if(r == 0){
                is_ha = 'b';//away win
              }
            }

            var wl = '';
            if( bet_info['tbet'] == is_ha){
              wl = 'w';
            }else{
              wl = 'l';
            }

            var od = bet_info['odd']
            if(bet_info['odTypId'] == this.$store.getters.oddTypesList.AM.key) {
              if(od<0){
                od=Math.abs(100/od);
              }else{
                od= (od / 100);
              }
              od= od.toFixed(3);
            }else if(od > 1) {
              od = bet_info['odd'] - 1
            }
            var wl_percentage = 1;
            var wl_amt  = 0;
            wl_amt = this.get_winlose_amt(wl,bet_info['betAmount'],od,wl_percentage, bet_info);
            arr_return['forecastInfo'][c+"_"+r] = wl_amt;

          }
        }
      }else{
        console.log('error -> olc_csh');
        return false;
      }
      return arr_return;
    },
    olc_twn(bet_info, hc, ac) {

      if( bet_info['tbet'] == 'a' || bet_info['tbet'] == 'b' ){
        var arr_return    = {};
        arr_return      = bet_info;
        arr_return['forecastInfo'] = {};

        for(var c=0;c<=hc;c++){
          for(var r=0;r<=ac;r++){
            //c = home team, r = away
            
            var is_ha = '';

            
            if(c > 0 && r == 0){
              is_ha = 'a';//home win
            }else if(r > 0 && c == 0){
              is_ha = 'b';//away win
            }

            var wl = '';
            if( bet_info['tbet'] == is_ha){
              wl = 'w';
            }else{
              wl = 'l';
            }

            var od = bet_info['odd']
            if(bet_info['odTypId'] == this.$store.getters.oddTypesList.AM.key) {
              if(od<0){
                od=Math.abs(100/od);
              }else{
                od= (od / 100);
              }
              od= od.toFixed(3);
            }else if(od > 1) {
              od = bet_info['odd'] - 1
            }
            var wl_percentage = 1;
            var wl_amt  = 0;
            wl_amt = this.get_winlose_amt(wl,bet_info['betAmount'],od,wl_percentage, bet_info);
            arr_return['forecastInfo'][c+"_"+r] = wl_amt;

          }
        }
      }else{
        console.log('error -> olc_csh');
        return false;
      }
      return arr_return;
    },
    olc_wm(bet_info, hc, ac) {

      var arr_return    = {};
      arr_return      = bet_info;
      arr_return['forecastInfo'] = {};

      if( $.inArray( bet_info['tbet'] , ['h1','h2','h3','h4','a1','a2','a3','a4','sd','ng']) == -1 ){
        console.log('error->olc_tg');
        return false;
      }

      for(var c=0;c<=hc;c++){
        for(var r=0;r<=ac;r++){
          //c = home team, r = away

          var wl = 'l';
          if( bet_info['tbet'] == 'h1' ){
            if( (parseFloat(c) - parseFloat(r) > 0) && (parseFloat(c) - parseFloat(r) == 1) ){
              wl = 'w';
            }
          }else if( bet_info['tbet'] == 'h2' ){
            if( (parseFloat(c) - parseFloat(r) > 0) && (parseFloat(c) - parseFloat(r) == 2) ){
              wl = 'w';
            }
          }else if( bet_info['tbet'] == 'h3' ){
            if( (parseFloat(c) - parseFloat(r) > 0) && (parseFloat(c) - parseFloat(r) == 3) ){
              wl = 'w';
            }
          }else if( bet_info['tbet'] == 'h4' ){
            if( (parseFloat(c) - parseFloat(r) > 0) && (parseFloat(c) - parseFloat(r) >= 4) ){
              wl = 'w';
            }
          }else if( bet_info['tbet'] == 'a1' ){
            if( (parseFloat(c) - parseFloat(r) < 0) && (parseFloat(c) - parseFloat(r) == -1) ){
              wl = 'w';
            }
          }else if( bet_info['tbet'] == 'a2' ){
            if( (parseFloat(c) - parseFloat(r) < 0) && (parseFloat(c) - parseFloat(r) == -2) ){
              wl = 'w';
            }
          }else if( bet_info['tbet'] == 'a3' ){
            if( (parseFloat(c) - parseFloat(r) < 0) && (parseFloat(c) - parseFloat(r) == -3) ){
              wl = 'w';
            }
          }else if( bet_info['tbet'] == 'a4' ){
            if( (parseFloat(c) - parseFloat(r) < 0) && (parseFloat(c) - parseFloat(r) <= -4) ){
              wl = 'w';
            }
          }else if( bet_info['tbet'] == 'sd' ){
            if( c != 0 || r != 0 ){
              if( parseFloat(c) - parseFloat(r) == 0 ){
                wl = 'w';
              }
            }
          }else if( bet_info['tbet'] == 'ng' ){
            if( c == 0 && r == 0 ){
              wl = 'w';
            }
          }

          var od = bet_info['odd']
          if(bet_info['odTypId'] == this.$store.getters.oddTypesList.AM.key) {
            if(od<0){
              od=Math.abs(100/od);
            }else{
              od= (od / 100);
            }
            od= od.toFixed(3);
          }else if(od > 1) {
            od = bet_info['odd'] - 1
          }

          var wl_percentage = 1;
          var wl_amt  = '-';
          wl_amt = this.get_winlose_amt(wl,bet_info['betAmount'],od,wl_percentage, bet_info);
          arr_return['forecastInfo'][c+"_"+r] = wl_amt;
        }
      }

      return arr_return;
    },
  }
}



// WEBPACK FOOTER //
// ./resources/wob/vue/mixins/forecastCalculation.js